export default "<div class=\"counter\">\n  <div *ngFor=\"let d of data\">\n    {{ d.key }}:\n    <b>{{ d.value }}</b>\n  </div>\n</div>"